import React from 'react';
import {ButtonBase} from '../elements';
import clsx from 'clsx';

interface NumButton {
    className: string;
    digit: string;
    addDigit: (digit: string) => void;
}

function NumButton(props: NumButton) {

    return (
        <ButtonBase className={clsx("flex grow-[1] justify-center items-center", props.className)} onClick={() => props.addDigit(props.digit)}>
            {props.digit}
        </ButtonBase>
    );
}

export default NumButton;
